module.exports = __webpack_public_path__ + "img/motorbike.590c9ceb.png";